const uploadMasterDataPath = '/Upload-Master-Data';
const restaurantPath = '/Restaurant';
const restaurantItemPath = '/Restaurant-Item';

export { uploadMasterDataPath, restaurantPath, restaurantItemPath };
